import actionTypes from '../actionTypes';

export function getErrorDialog() {
	return {
		type: actionTypes.GET_ERROR_DIALOG,
	};
}

export function getBusinessHierarchy(params) {
	return {
		type: actionTypes.GET_BUSINESS_HIERARCHY,
		payload: params,
	};
}

export function getBusinessHierarchySuccess(result) {
	return {
		type: actionTypes.GET_BUSINESS_HIERARCHY_SUCCESS,
		payload: result,
	};
}

export function getBusinessHierarchyFailure(error) {
	return {
		type: actionTypes.GET_BUSINESS_HIERARCHY_FAILURE,
		payload: error,
	};
}

export function getSavedHierarchy(params) {
	return {
		type: actionTypes.GET_SAVED_HIERARCHY,
		payload: params,
	};
}

export function getSavedHierarchySuccess(result) {
	return {
		type: actionTypes.GET_SAVED_HIERARCHY_SUCCESS,
		payload: result,
	};
}

export function getSavedHierarchyFailure(error) {
	return {
		type: actionTypes.GET_SAVED_HIERARCHY_FAILURE,
		payload: error,
	};
}

export function saveHierarchy(params) {
	return {
		type: actionTypes.SAVE_HIERARCHY,
		payload: params,
	};
}

export function saveHierarchySuccess(result) {
	return {
		type: actionTypes.SAVE_HIERARCHY_SUCCESS,
		payload: result,
	};
}

export function saveHierarchyFailure(error) {
	return {
		type: actionTypes.SAVE_HIERARCHY_FAILURE,
		payload: error,
	};
}

export function saveHierarchyFilter(params) {
	return {
		type: actionTypes.SAVE_HIERARCHY_FILTER,
		payload: params,
	};
}

export function openHierarchy(params) {
	return {
		type: actionTypes.OPEN_HIERARCHY_MODAL,
		payload: params,
	};
}

export function clickApplyButton(params) {
	return {
		type: actionTypes.CLICK_APPLY,
		payload: params,
	};
}

export function saveSearchedHierarchy(params) {
	return {
		type: actionTypes.SAVE_SEARCHED_HEIRARCHY,
		payload: params,
	};
}

export function clearSearchedHierarchy(params) {
	return {
		type: actionTypes.CLEAR_SEARCHED_HEIRARCHY,
		payload: params,
	};
}

export function deleteSavedHierarchy(params) {
	return {
		type: actionTypes.DELETE_SAVED_HIERARCHY,
		payload: params,
	};
}

export function deleteSavedHierarchySuccess(params) {
	return {
		type: actionTypes.DELETE_SAVED_HIERARCHY_SUCCESS,
		payload: params,
	};
}

export function deleteSavedHierarchyFailure(params) {
	return {
		type: actionTypes.DELETE_SAVED_HIERARCHY_FAILURE,
		payload: params,
	};
}

export function editSavedHierarchy(params) {
	return {
		type: actionTypes.EDIT_SAVED_HIERARCHY,
		payload: params,
	};
}

export function editSavedHierarchySuccess(params) {
	return {
		type: actionTypes.EDIT_SAVED_HIERARCHY_SUCCESS,
		payload: params,
	};
}

export function editSavedHierarchyFailure(params) {
	return {
		type: actionTypes.EDIT_SAVED_HIERARCHY_FAILURE,
		payload: params,
	};
}

export function setSelectedHierarchy(params) {
	return {
		type: actionTypes.SET_SELECTED_HIERARCHY,
		payload: params,
	};
}

export function setHierarchyFilterRhId(params) {
	return {
		type: actionTypes.SET_HIERRCHY_FILTER_RHID,
		payload: params,
	};
}

export function setEditFlow(params) {
	return {
		type: actionTypes.SET_EDIT_FLOW,
		payload: params,
	};
}

export function setEditHierarchy(params) {
	return {
		type: actionTypes.SET_EDIT_HIERARCHY,
		payload: params,
	};
}

export function validateHierarchy(params) {
	return {
		type: actionTypes.VALIDATE_HIERARCHY,
		payload: params,
	};
}

export function validateHierarchySuccess(params) {
	return {
		type: actionTypes.VALIDATE_HIERARCHY_SUCCESS,
		payload: params,
	};
}

export function validateHierarchyFailure(params) {
	return {
		type: actionTypes.VALIDATE_HIERARCHY_FAILURE,
		payload: params,
	};
}

export function resetValidateHierarchy() {
	return {
		type: actionTypes.RESET_VALIDATE_HIERARCHY,
	};
}

export function updateSavedHierarchy(params) {
	return {
		type: actionTypes.UPDATE_SAVED_HIERARCHY,
		payload: params,
	};
}

export function updateSavedHierarchySuccess(params) {
	return {
		type: actionTypes.UPDATE_SAVED_HIERARCHY_SUCCESS,
		payload: params,
	};
}

export function updateSavedHierarchyFailure(params) {
	return {
		type: actionTypes.UPDATE_SAVED_HIERARCHY_FAILURE,
		payload: params,
	};
}

export function editSelectedHierarchy(params) {
	return {
		type: actionTypes.EDIT_SELECTED_HIERARCHY,
		payload: params,
	};
}

export function resetFullCompanyViewReducer() {
	return {
		type: actionTypes.RESET_FULL_COMPANY_VIEW_REDUCER,
	};
}

export function getUserAuth(params) {
	return {
		type: actionTypes.GET_USER_AUTH,
		payload: params,
	};
}
